export default __webpack_public_path__ + "static/media/Djeco-Biganimals-1.598a8353.jpg";